<template>
  <v-app>
    <v-app-bar app flat id="appbar">
      <v-toolbar-title class="dp-title" @click="onClickTitle()">
        {{ toolbarTitle }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <template v-if="!keycloak.authenticated">
        <v-btn text @click="goTo('project-list')">{{$t('navbar.signIn')}}</v-btn>
        <v-btn text @click="goTo('registration')">{{$t('navbar.register')}}</v-btn>
      </template>
      <template v-if="keycloak.authenticated">
        <template v-if="isTester">
          <v-btn text @click="goTo('diagnosis-dashboard')">{{$t('navbar.diagnosis')}}</v-btn>
        </template>
        <template v-if="isPathologist">
          <v-btn text @click="goTo('annotator-dashboard')">{{$t('navbar.dashboard')}}</v-btn>
          <v-btn text @click="goTo('annotator-list')">{{$t('navbar.myContributions')}}</v-btn>
          <v-btn text @click="goTo('service')">{{$t('navbar.services')}}</v-btn>
        </template>
        <v-btn text @click="goTo('project-list')" v-if="isResearcher"
          >{{$t('navbar.projects')}}
        </v-btn>
        <template v-if="isImageOwner">
          <v-btn text @click="goTo('contributor')">{{$t('navbar.contributor')}}</v-btn>
          <v-btn text @click="goTo('contributor-list')">{{$t('navbar.myContributions')}}</v-btn>
        </template>
        <v-btn
          v-if="isImageOwner || isPathologist"
          text
          @click="goTo('tokens-list')"
          >{{$t('navbar.myTokens')}}</v-btn
        >

        <v-menu
          offset-y
          :close-on-content-click="false"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              text
              @click="showAccountMenu = true"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-account</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              {{ userEmail }}
            </v-list-item>
            <v-list-item>
              {{ userRoles | role }}
            </v-list-item>
            <v-divider />
            <v-list-item link @click="goToAccountManagement">
              <v-list-item-icon>
                <v-icon>mdi-account</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{$t('navbar.accountManagement')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item link @click="logout">
              <v-list-item-icon>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>{{$t('navbar.signOut')}}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-list-item-icon>
                <v-icon>mdi-web</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <Locale-changer/>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-app-bar>
    <v-main>
      <v-container :fluid="fluid" :style="style">
        <router-view></router-view>
      </v-container>
    </v-main>

    <notifications />

    <!-- <v-footer app></v-footer> -->
  </v-app>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import LocaleChanger from "@/components/LocaleChanger";
import {
  ACTION_SET_CURRENT_PROJECT,
  FIND,
  MY_PROJECTS
} from "@/store/modules/project";

export default {
  data: () => ({
    showAccountMenu: false,
    userEmail: null,
    userRoles: null,
    fullHeightViews: [
      "annotator-visualize",
      "diagnose-visualize",
      "annotator-validation",
      "slide-view",
      "service-view",
      "home"
    ]
  }),
  computed: {
    ...mapState({
      keycloak: state => state.authentication.keycloak,
      currentProject: state => state.project.currentProject
    }),
    ...mapGetters({
      isResearcher: "isResearcher",
      isPathologist: "isPathologist",
      isImageOwner: "isImageOwner",
      isTester: "isTester"
    }),
    fluid() {
      return this.fullHeightViews.includes(this.$route.name);
    },
    style() {
      if (this.fullHeightViews.includes(this.$route.name)) {
        return { height: "100%", margin: 0, padding: 0 };
      }

      return {};
    },
    toolbarTitle() {
      const title = this.$t("navbar.title");
      if (!this.keycloak.authenticated || !this.isResearcher) return title;
      if (this.currentProject) return this.currentProject.project_name;
      return title;
    }
  },
  methods: {
    onClickTitle() {
      if (!this.keycloak.authenticated) {
        this.goTo("home");
        return;
      }
      if (this.isResearcher && this.currentProject) {
        this.goToCurrentProject();
        return;
      }
      if (this.isTester) {
        // this.goTo("diagnosis-dashboard")
        this.goTo("home");
      }
      if (this.isPathologist) {
        // this.goTo("annotator-dashboard");
        this.goTo("home");
      } else this.goTo("home");
    },
    goTo(name) {
      if (this.$route.name !== name) {
        this.$router.push({ name });
      }
    },
    goToProject(project) {
      this.$store.dispatch(ACTION_SET_CURRENT_PROJECT, { project });
      this.$router.push({ name: "project", params: { id: project.id } });
    },
    goToCurrentProject() {
      if (this.currentProject) {
        this.$router.push({
          name: "project",
          params: { id: this.currentProject.id }
        });
      }
    },
    logout() {
      this.keycloak.logout({
        redirectUri: process.env.VUE_APP_REDIRECT_URL_AFTER_LOGOUT
      });
    },
    goToAccountManagement() {
      this.keycloak.accountManagement();
    },
    goToAnnotator() {
      window.location.href = "http://craiyon.deeppath.scian.cl/slides";
    }
  },
  mounted() {
    if (this.keycloak.authenticated) {
      this.userEmail = this.keycloak.tokenParsed.email;
      this.userRoles = this.keycloak.tokenParsed.realm_access.roles;
    }
  },
  components: {
    LocaleChanger
  }
};
</script>
<style lang="scss">
.page {
  margin-top: 16px;
}

.dp-title {
  cursor: pointer;
}
</style>

<style lang="css">
.table >>> tbody tr :hover {
  cursor: pointer !important;
}
</style>
